export const SET_USERTOKEN = 'SET_USERTOKEN';
export const SET_USERINFO = 'SET_USERINFO';